export class CacheConstant {
  static readonly StaticData = {
    NuctracGroup: 'nuctrac-group',
    TypeGroup: 'typeGroupRefList',
    TypeRef: 'typeRefList',
    MessageRef: 'messageRefList',
    AppPreference: 'appPreferenceList',
    TimeZone: 'timezoneList',
    Pages: 'pageList',
    TemplateCategory: 'templateCategoryList',
    Details: "Details"
  };


  static readonly SessionStorageData = {
    AuthenticationToken: 'authenticationToken',
    AccessToken: 'accessToken',
    IdToken: 'idToken',
    ShipTo: 'shipto',
    Permissions: 'permissions',
    NuctracAppPreferences: 'nuctracAppPreferences',
    NuctracAppMaintenance: 'nuctracAppMaintenance',
    LoggedInUser: 'loggedInUser',
    LoggedInUserID: "loggedInUserID",
    AllDigiRadDepartments: 'allDigiRadDepartments',
    CustomerSsoFlag: 'customerSsoFlag',
    IsAccountHuborFacility: 'isAccountHuborFacility',
    LocationNumber: 'locationNumber',
    SsoValidationFlag: 'ssoValidationFlag',
    UserSsoFlag: 'userSsoFlag',
    DefaultShipTo: 'DefaultShipTo',
    TimeZoneText: 'timeZoneText',
    Email: 'email',
    nuctracRejectNotificationTiming:'nuctracRejectNotificationTiming',
    InventoryNum:'inventoryNum',
    Shipments:'shipments',
    AssayScreenFlg : 'assayScreenFlg',
    EnablePoFlag: 'enablePoFlag',
  };

  static readonly LocalStorage = {
    ActiveUsersList: 'active-user-list',
    Preferences: 'preferences',
    Procedures: 'procedures',
    Specialitydata: 'specialityData',
    SpecialProducts: 'specialProducts',
    Uoms: 'uoms',
    Vendors: 'vendor',
    Mobile:'mobile',
    reservations:'reservations',
    NuctracEssentials:'nuctracEssentials',
    route:'route',
    site:'site',
    DeliveryAddress: 'deliveryAddress'
  };


  static readonly AppData = { UserProfile: "UserProfile", SessionExpired: "SessionExpired", Roles: "Roles", Email: "Email", AccountSettings: "AccountSettings", NuctracGroups: "NuctracGroups", NuctracModules: "NuctracModules", NuctracProducts: "NuctracProducts", NuctracOrders: "NuctracOrders" };
  static readonly _cacheNames = { appData: 'App', staticData: 'Static', httpHeaders: 'HttpHeaders' }

  static readonly MasterData = {
    Customer: 'customer-data',
    Item: 'item'

  };

  static readonly OktaAuth = 'okta-auth';
  static readonly UserAuth = 'user-auth';
  static readonly UserPreferences = 'user-preferences';
  static readonly UserRole = 'userRole';

  static readonly DataCache = {
    Asv: 'asv-types',
    SelectedQuarantinePanel: 'selected-quarantine-panel',
  };
}
